import RequestAdapter from '../adapters/RequestAdapter';
import { API_V3_PATH_BASE } from '../constants';
import { ENDPOINTS } from '../enums/endpoints';
import Bugsnag from '@bugsnag/js';

/**
 * Fetch a list of phone codes
 *
 * @function
 * @returns {object} JSON response
 */
const getPlansList = () => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.CHECKOUT.PLANS}`,
    method: 'GET',
  };

  try {
    return RequestAdapter.request(requestConfig);
  } catch (e) {
    Bugsnag.notify(e);
    throw e;
  }
};

const getPlansFeatures = () => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.CHECKOUT.FEATURES}`,
    method: 'GET',
  };

  try {
    return RequestAdapter.request(requestConfig);
  } catch (e) {
    Bugsnag.notify(e);
    throw e;
  }
};

const submitOrderSummary = (plan_id, cycle, coupon) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.CHECKOUT.ORDER_SUMMARY}`,
    method: 'POST',
    body: JSON.stringify({
      summary: {
        plan_id,
        cycle,
        coupon,
      },
    }),
  };

  try {
    return RequestAdapter.request(requestConfig);
  } catch (e) {
    Bugsnag.notify(e);
    throw e;
  }
};

const getPaymentMethod = () => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.CHECKOUT.METHOD}`,
    method: 'GET',
  };

  try {
    return RequestAdapter.request(requestConfig);
  } catch (e) {
    Bugsnag.notify(e);
    throw e;
  }
};

const paymentAuthorization = (
  plan_id,
  cycle,
  currency,
  payment_methods,
  keep_method,
  summary
) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.CHECKOUT.PAYMENTS}`,
    method: 'POST',
    body: JSON.stringify({
      plan_id,
      cycle,
      currency,
      payment_methods,
      keep_method,
      ...summary,
    }),
  };

  try {
    return RequestAdapter.request(requestConfig);
  } catch (e) {
    Bugsnag.notify(e);
    throw e;
  }
};

const paymentSubscription = (
  plan_id,
  cycle,
  amount,
  currency,
  payment_methods,
  discount_coupon,
  discount_percentage,
  transaction_id,
  payment_id
) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.CHECKOUT.SUBSCRIPTION}`,
    method: 'POST',
    body: JSON.stringify({
      plan_id,
      cycle,
      amount,
      currency,
      payment_methods,
      discount_coupon,
      discount_percentage,
      transaction_id,
      payment_id,
    }),
  };

  try {
    return RequestAdapter.request(requestConfig);
  } catch (e) {
    Bugsnag.notify(e);
    throw e;
  }
};

const getFreePlanSetup = (plan_id, cycle) => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.CHECKOUT.FREE_PLAN_SETUP}`,
    method: 'POST',
    body: JSON.stringify({
      plan_id,
      cycle,
    }),
  };

  try {
    return RequestAdapter.request(requestConfig);
  } catch (e) {
    Bugsnag.notify(e);
    throw e;
  }
};

export const CheckoutService = {
  getPlansList,
  getPlansFeatures,
  submitOrderSummary,
  getPaymentMethod,
  paymentAuthorization,
  paymentSubscription,
  getFreePlanSetup,
};
